import { render, staticRenderFns } from "./task.vue?vue&type=template&id=fdfe9cb8&scoped=true&"
import script from "./task.vue?vue&type=script&lang=ts&"
export * from "./task.vue?vue&type=script&lang=ts&"
import style0 from "./task.vue?vue&type=style&index=0&id=fdfe9cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe9cb8",
  null
  
)

export default component.exports